import { fetchMyself } from 'actions/myself';
import { clearCache as clearCardCache } from 'actions/cards';
import { clearCache as clearStoryletCache } from 'actions/storylet';
import { fetchPlans } from 'actions/plans';
import { handleVersionMismatch } from 'actions/versionSync';

import { EQUIP_QUALITY_FAILURE, EQUIP_QUALITY_REQUESTED, EQUIP_QUALITY_SUCCESS, } from 'actiontypes/myself';
import { VersionMismatch } from 'services/BaseService';

export const equipQualityRequested = () => ({ type: EQUIP_QUALITY_REQUESTED });

export const equipQualitySuccess = (data: { name: string, qualityId: number }) => ({
  type: EQUIP_QUALITY_SUCCESS,
  payload: data
});

export const equipQualityFailure = (error: any) => ({
  type: EQUIP_QUALITY_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

export default function changeEquipped(action: (qualityId: number) => Promise<{ data: { name: string, qualityId: number } }>) {
  return (qualityId: number) => async (dispatch: Function) => {
    dispatch(equipQualityRequested());

    // Clear the cache, because storylet and card eligibility may have changed as
    // a result of equipment changes
    dispatch(clearCardCache());
    dispatch(clearStoryletCache());

    try {
      const { data } = await action(qualityId);
      dispatch(equipQualitySuccess(data));

      // Re-fetch plans in case the user has qualified/disqualified themselves
      // for a plan
      dispatch(fetchPlans());
      // Re-fetch /myself so that modified qualities are synced
      dispatch(fetchMyself());
      // Return data so that we can chain on it
      return data;
    } catch (err) {
      if (err instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(err));
        return;
      }
      dispatch(equipQualityFailure(err));
      throw err;
    }
  };
}